<div class="overflow-auto">
  <div class="pronouncement-container print-content print-all-content">
    <div class="top-heading content-blue">{{header}}</div>
    <div id="mainText" class="font-16 navDescriptionText" [innerHTML]="contentlinks"></div>
  </div>
</div>
